import { CoreIcon } from '../core-icon';
import pinQuestionFillSVG from '../../assets/icons/pin-question-fill.svg';
import type { IconProps } from '../core-icon';

export const PinQuestionFillIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={pinQuestionFillSVG} {...props} />;
};
